<div class="cm-page-wrapper">
  <p-toast></p-toast>

  <app-page-header
    title="Cash Management"
    [subtitle]="isPettyCashEnabled ? 'Petty cash and customer credits' : 'Customer credits'"
    icon="pi pi-wallet"
    (back)="goBackToHome()"
  ></app-page-header>

  <!-- ─── Main Tab Shell ─── -->
  <div class="cm-tab-shell">
    <p-tabView [(activeIndex)]="activeTabIndex" styleClass="cm-tabview">

      <!-- ══════════════ PETTY CASH ══════════════ -->
      <!-- *ngIf (not just hiding): TabView builds every panel, so this also stops petty cash APIs -->
      <p-tabPanel *ngIf="isPettyCashEnabled">
        <ng-template pTemplate="header">
          <div class="cm-tab-pill">
            <i class="pi pi-dollar cm-tab-icon"></i>
            <span>Petty Cash</span>
          </div>
        </ng-template>
        <div class="cm-tab-body">
          <app-petty-cash [embedded]="true"></app-petty-cash>
        </div>
      </p-tabPanel>

      <!-- ══════════════ CUSTOMER CREDITS ══════════════ -->
      <p-tabPanel>
        <ng-template pTemplate="header">
          <div class="cm-tab-pill">
            <i class="pi pi-users cm-tab-icon"></i>
            <span>Customer Credits</span>
          </div>
        </ng-template>

        <div class="cm-tab-body">

          <!-- Hero Search Bar -->
          <div class="cm-hero-search">
            <div class="cm-hero-search-inner">
              <i class="pi pi-search cm-hero-search-icon"></i>
              <div class="cm-hero-autocomplete-wrap">
                <p-autoComplete
                  id="customerSearch"
                  [(ngModel)]="selectedCustomer"
                  [suggestions]="filteredCustomers"
                  (completeMethod)="filterCustomers($event)"
                  (onSelect)="onCustomerSelect($event)"
                  field="customer_name"
                  [dropdown]="true"
                  placeholder="Search customer by name or mobile number…"
                  styleClass="cm-hero-autocomplete"
                >
                  <ng-template let-customer pTemplate="item">
                    <div class="cm-customer-option">
                      <span class="cm-customer-name">{{ customer.customer_name }}</span>
                      <span class="cm-customer-mobile">{{ customer.mobile_no }}</span>
                    </div>
                  </ng-template>
                </p-autoComplete>
              </div>
            </div>
            <div class="cm-search-meta">
              <span class="cm-search-count"><i class="pi pi-users"></i> {{ customers.length }} customers</span>
              <span *ngIf="selectedCustomer?.mobile_no" class="cm-selected-chip">
                <i class="pi pi-check-circle"></i>
                {{ selectedCustomer?.customer_name }} &nbsp;·&nbsp; {{ selectedCustomer?.mobile_no }}
              </span>
            </div>
          </div>

          <!-- Empty State -->
          <div class="cm-empty-state" *ngIf="!selectedCustomer?.mobile_no">
            <div class="cm-empty-icon-ring">
              <i class="pi pi-users"></i>
            </div>
            <h5 class="cm-empty-title">No Customer Selected</h5>
            <p class="cm-empty-desc">Search and select a customer above to view their payment due and sale return details.</p>
          </div>

          <!-- Nested Tabs (only when customer selected) -->
          <div class="cm-nested-tab-shell" *ngIf="selectedCustomer?.mobile_no">
            <p-tabView styleClass="cm-nested-tabview">

              <!-- ── Payment Due ── -->
              <p-tabPanel>
                <ng-template pTemplate="header">
                  <div class="cm-tab-pill cm-tab-pill-sm">
                    <i class="pi pi-credit-card cm-tab-icon"></i>
                    <span>Sale Payment Due Details</span>
                  </div>
                </ng-template>

                <div class="cm-inner-tab-body" *ngIf="paymentDueData">
                  <!-- Summary Bar -->
                  <div class="cm-summary-bar">
                    <div class="cm-summary-item">
                      <span class="cm-summary-label">Total Amount</span>
                      <span class="cm-summary-value">₹{{ paymentDueData.customerTotalamount | number:'1.2-2' }}</span>
                    </div>
                    <div class="cm-summary-divider"></div>
                    <div class="cm-summary-item">
                      <span class="cm-summary-label">Paid Amount</span>
                      <span class="cm-summary-value is-success">₹{{ paymentDueData.customerPaidamount | number:'1.2-2' }}</span>
                    </div>
                    <div class="cm-summary-divider"></div>
                    <div class="cm-summary-item">
                      <span class="cm-summary-label">Overdue Amount</span>
                      <span class="cm-summary-value is-danger">₹{{ paymentDueData.customerOverdue | number:'1.2-2' }}</span>
                    </div>
                    <div class="cm-summary-divider"></div>
                    <div class="cm-summary-item">
                      <span class="cm-summary-label">Selected Amount</span>
                      <span class="cm-summary-value is-accent">₹{{ paymentData.totalAmount | number:'1.2-2' }}</span>
                    </div>
                  </div>

                  <!-- Payment Due Table -->
                  <div class="cm-table-wrap">
                    <p-table
                      [value]="paymentDueData.data"
                      styleClass="p-datatable-sm cm-modern-table"
                      [scrollable]="true"
                      scrollHeight="220px"
                      [responsive]="true"
                    >
                      <ng-template pTemplate="header">
                        <tr>
                          <th class="col-select">Select</th>
                          <th>Sale ID</th>
                          <th>Total Sale Amount</th>
                          <th>Total Paid</th>
                          <th>Balance Due</th>
                          <th>Partial Amount</th>
                          <th>Status</th>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-item>
                        <tr>
                          <td>
                            <input
                              *ngIf="item.balanceAmountDue > 0"
                              type="checkbox"
                              [checked]="isPaymentItemSelected(item)"
                              (change)="onPaymentItemToggle(item, $any($event.target).checked)"
                              class="cm-checkbox"
                            />
                            <span *ngIf="item.balanceAmountDue <= 0">
                              <i class="pi pi-check-circle cm-paid-icon"></i>
                            </span>
                          </td>
                          <td>{{ item.saleid }}</td>
                          <td>₹{{ item.totalSaleAmount | number:'1.2-2' }}</td>
                          <td>₹{{ item.totalPaid | number:'1.2-2' }}</td>
                          <td class="cm-amount is-danger">₹{{ item.balanceAmountDue | number:'1.2-2' }}</td>
                          <td>
                            <input
                              *ngIf="item.balanceAmountDue > 0"
                              type="number"
                              [(ngModel)]="item.partialPaymentAmount"
                              [max]="item.balanceAmountDue"
                              [min]="0"
                              step="0.01"
                              [disabled]="!isPaymentItemSelected(item)"
                              (blur)="onPartialAmountChange(item)"
                              (change)="onPartialAmountChange(item)"
                              placeholder="Enter amount"
                              class="cm-partial-input"
                            />
                            <span *ngIf="item.balanceAmountDue <= 0" class="cm-muted">—</span>
                          </td>
                          <td>
                            <span [class]="'cm-status-badge ' + (item.isFullyPaid ? 'badge-paid' : 'badge-pending')">
                              {{ item.isFullyPaid ? 'Fully Paid' : 'Pending' }}
                            </span>
                          </td>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="emptymessage">
                        <tr>
                          <td colspan="7">
                            <div class="cm-table-empty">
                              <i class="pi pi-info-circle"></i>
                              <span>No payment due items found</span>
                            </div>
                          </td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </div>

                  <!-- Proceed Button -->
                  <div class="cm-action-row" *ngIf="selectedPaymentItems.length > 0">
                    <button type="button" class="premium-btn premium-btn-primary" (click)="proceedToPayment()">
                      <i class="pi pi-credit-card"></i>
                      Proceed to Payment
                    </button>
                  </div>
                </div>
              </p-tabPanel>

              <!-- ── Sale Returns ── -->
              <p-tabPanel>
                <ng-template pTemplate="header">
                  <div class="cm-tab-pill cm-tab-pill-sm">
                    <i class="pi pi-replay cm-tab-icon"></i>
                    <span>Sale Return Details</span>
                  </div>
                </ng-template>

                <div class="cm-inner-tab-body" *ngIf="selectedCustomer?.mobile_no">
                  <!-- Summary Bar -->
                  <div class="cm-summary-bar">
                    <div class="cm-summary-item">
                      <span class="cm-summary-label">Total Credit Available</span>
                      <span class="cm-summary-value is-success">₹{{ saleReturnsSummary.totalCreditAvailable | number:'1.2-2' }}</span>
                    </div>
                    <div class="cm-summary-divider"></div>
                    <div class="cm-summary-item">
                      <span class="cm-summary-label">Total Refunds Processed</span>
                      <span class="cm-summary-value is-info">₹{{ saleReturnsSummary.totalRefundsProcessed | number:'1.2-2' }}</span>
                    </div>
                    <div class="cm-summary-divider"></div>
                    <div class="cm-summary-item">
                      <span class="cm-summary-label">Total Returns Count</span>
                      <span class="cm-summary-value is-accent">{{ saleReturnsSummary.totalReturnsCount }}</span>
                    </div>
                  </div>

                  <!-- Sale Returns Table -->
                  <div class="cm-table-wrap" *ngIf="!saleReturnsLoading && !saleReturnsError">
                    <p-table
                      [value]="saleReturnsData"
                      styleClass="p-datatable-sm cm-modern-table"
                      [scrollable]="true"
                      scrollHeight="220px"
                      [responsive]="true"
                    >
                      <ng-template pTemplate="header">
                        <tr>
                          <th>Return OrderID</th>
                          <th>Invoice Number</th>
                          <th>Return Invoice Date</th>
                          <th>Total Amount</th>
                          <th>Credit Amount</th>
                          <th>Refund Total</th>
                          <th>Status</th>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-item>
                        <tr>
                          <td>{{ item.return_uuid }}</td>
                          <td>{{ item.invoiceno }}</td>
                          <td>{{ item.invoicedate | date:'medium' }}</td>
                          <td>₹{{ item.grandtotal | number:'1.2-2' }}</td>
                          <td class="cm-amount is-success">₹{{ item.creditamount | number:'1.2-2' }}</td>
                          <td>₹{{ item.refundtotal | number:'1.2-2' }}</td>
                          <td>
                            <span [class]="'cm-status-badge ' + (item.status === 'Credit' ? 'badge-credit' : 'badge-info')">
                              {{ item.status }}
                            </span>
                          </td>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="emptymessage">
                        <tr>
                          <td colspan="7">
                            <div class="cm-table-empty">
                              <i class="pi pi-info-circle"></i>
                              <span>No sale returns found for this customer</span>
                            </div>
                          </td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </div>

                  <!-- Loading -->
                  <div *ngIf="saleReturnsLoading" class="cm-loading-state">
                    <p-progressSpinner
                      [style]="{ width: '48px', height: '48px' }"
                      strokeWidth="4"
                      fill="transparent"
                      animationDuration=".6s"
                    ></p-progressSpinner>
                    <span>Loading sale returns…</span>
                  </div>

                  <!-- Error -->
                  <div *ngIf="saleReturnsError && !saleReturnsLoading" class="cm-error-alert">
                    <i class="pi pi-exclamation-triangle"></i>
                    {{ saleReturnsError }}
                  </div>
                </div>
              </p-tabPanel>

            </p-tabView>
          </div>
          <!-- /nested tabs -->

        </div>
        <!-- /cm-tab-body -->
      </p-tabPanel>

    </p-tabView>
  </div>
  <!-- /cm-tab-shell -->

</div>

<!-- Payment Dialog (unchanged) -->
<app-payment-dialog
  [(visible)]="showPaymentDialog"
  (visibleChange)="!$event && onPaymentDialogClose()"
  [config]="paymentDialogConfig"
  [(paymentData)]="paymentData"
  [isProcessing]="isPaymentProcessing"
  [customers]="customers"
  (paymentProcess)="onPaymentProcess($event)"
>
</app-payment-dialog>
